module.exports = __webpack_public_path__ + "img/lounge_cover.69d4f844.jpg";